module.exports = __webpack_public_path__ + "static/media/bg-grass-desk.423ce030.svg";